import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constant/baseurl";
import { apiCall } from "../../api/index";
import { showLoading } from "../slice/loadingSlice";



const createAccountAsyncThunk = (method, type, contentType, url) =>
  createAsyncThunk(type, async (payload, thunkAPI) => {
    const { data } = payload;
    const { dispatch } = thunkAPI;
    const token = localStorage.getItem("token");
    const apiRequest = {
      method: method,
      headers: token
        ? {
            "Content-Type": contentType,
            Authorization: "Token " + localStorage.getItem("token"),
          }
        : { "Content-Type": contentType },
      url: `${baseUrl}${url}`,
      data,
    };

    try {
      dispatch(showLoading.actions.toggleLoading(true));
      const res = await apiCall(apiRequest, dispatch);
      const response = res.data;

      dispatch(showLoading.actions.toggleLoading(false));

      if (response.statusFlag === true) {
        // console.log(`login action ------ ${type}`, response);
        return response;
      } else {
        // console.error(`account action - ${type}`, response);

        // Check if there is an error code in the response
        const errorCode = response.message;

        // You can throw a custom error with the error code
        throw new Error(errorCode);
      }
    } catch (error) {
      dispatch(showLoading.actions.toggleLoading(false));
      throw error;
    }
  });

  export const adminNotificationList = createAccountAsyncThunk(
    "post",
    "adminNotificationList",
    "application/json",
    "valiantinfo_admin/notification_service/notification_list/"
  );
  
  export const adminDeleteNotification = createAccountAsyncThunk(
    "post",
    "adminNotificationList",
    "application/json",
    "valiantinfo_admin/notification_service/delete_notifications/"
  );
  

  export const adminReadByUser = createAccountAsyncThunk(
    "post",
    "adminReadByUser",
    "application/json",
    "valiantinfo_admin/notification_service/admin_notifications_read/"
  );

  export const adminReadAllMessage = createAccountAsyncThunk(
    "post",
    "adminReadAllMessage",
    "application/json",
    "valiantinfo_admin/notification_service/admin_notifications_read_all_message/"
  );

  export const adminDeleteAllMessage = createAccountAsyncThunk(
    "post",
    "adminDeleteAllMessage",
    "application/json",
    "valiantinfo_admin/notification_service/admin_notifications_delete_all_message/"
  );